import moment from "moment";

const calculateTotalDays = (pickupDate: string, dropOffDate: string) => {
  const start = moment(pickupDate);
  const end = moment(dropOffDate);
  // Calculate difference in hours (with decimals for minutes/seconds)
  const hoursDiff = end.diff(start, "hours", true);

  // If <= 25 hours (24 + 1 hour margin), it's 1 day
  if (hoursDiff <= 25) {
    return 1;
  }

  // For > 25 hours, calculate days based on 24-hour periods
  // Subtract 1 hour (the margin) and divide by 24, then round up
  const days = Math.ceil((hoursDiff - 1) / 24);

  // Ensure minimum of 1 day
  return Math.max(1, days);
};
const calculatePrice = (
  dailyRate: number,
  weeklyRate: number,
  monthlyRate: number,
  pickupDate: string,
  dropoffDate: string
) => {
  // Calculate total number of days
  const totalDays = calculateTotalDays(pickupDate, dropoffDate);
  

  let price = 0;

  if (totalDays >= 30) {
    price = totalDays * monthlyRate;
  } else if (totalDays >= 7) {
    price = totalDays * weeklyRate;
  } else {
    price = totalDays * dailyRate;
  }

  // Do not round here: VAT and totals are derived from this net rental amount.
  // Rounding first (e.g. 1168.6995 → 1169) skews VAT and the gross total; UI uses toFixed(2).
  return price;
};

export default calculatePrice;

export const formatDateForAPI = (dateObj: any): string => {
  if (!dateObj || !dateObj.date) return "";
  return moment(dateObj.date).format("YYYY-MM-DD");
};

export const calculateDiscountPercentage = (
  dailyRate: number,
  discountedRate: number,
  days: number
) => {
  const originalTotal = dailyRate * days;
  const discountedTotal = discountedRate * days;
  const discount = ((originalTotal - discountedTotal) / originalTotal) * 100;
  return Math.round(discount); // round to nearest whole number
};
